// // https://en.wikipedia.org/wiki/Well-known_text_representation_of_geometry
// We only care about supporting these data types for now
export var WktDataType;
(function (WktDataType) {
    WktDataType["Point"] = "POINT";
    WktDataType["MultiPoint"] = "MULTIPOINT";
    WktDataType["LineString"] = "LINESTRING";
    WktDataType["MultiLineString"] = "MULTILINESTRING";
    WktDataType["Polygon"] = "POLYGON";
    WktDataType["MultiPolygon"] = "MULTIPOLYGON";
    WktDataType["GeometryCollection"] = "GEOMETRYCOLLECTION";
})(WktDataType || (WktDataType = {}));
;
// Serialize a single WKT (x, y) or (lon, lat) point
export function wktPointToString(point) {
    return `${point[0]} ${point[1]}`;
}
// Serialize a list of WKT points, for example a LineString
export function wktPointListToString(points) {
    return "(" + points.map(wktPointToString).join(", ") + ")";
}
// Serialize a list of lists of WKT points, for example a Polygon
export function wktPointListListToString(points) {
    return "(" + points.map(wktPointListToString).join(", ") + ")";
}
// Serialize a list of lists of lists of WKT points, for example a MultiPolygon
export function wktPointListListListToString(points) {
    return "(" + points.map(wktPointListListToString).join(", ") + ")";
}
export class Wkt {
    type;
    data;
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
    toString() {
        return String(this.type) + " " + this.dataToString();
    }
    dataToString() {
        if (!this.data) {
            return "EMPTY";
        }
        else if (Array.isArray(this.data) && !this.data.length) {
            return "EMPTY";
        }
        else if (this.type === WktDataType.Point) {
            return "(" + wktPointToString(this.data) + ")";
        }
        else if (this.type === WktDataType.MultiPoint) {
            return wktPointListToString(this.data);
        }
        else if (this.type === WktDataType.LineString) {
            return wktPointListToString(this.data);
        }
        else if (this.type === WktDataType.MultiLineString) {
            return wktPointListListToString(this.data);
        }
        else if (this.type === WktDataType.Polygon) {
            return wktPointListListToString(this.data);
        }
        else if (this.type === WktDataType.MultiPolygon) {
            return wktPointListListListToString(this.data);
        }
        else if (this.type === WktDataType.GeometryCollection) {
            return "(" + this.data.map(toString).join(", ") + ")";
        }
        else {
            throw new Error("Unknown WKT data type.");
        }
    }
}
(function (Wkt) {
    Wkt.DataType = WktDataType;
})(Wkt || (Wkt = {}));
export default Wkt;
//# sourceMappingURL=wkt.js.map